import { render, staticRenderFns } from "./UserActivityTab.vue?vue&type=template&id=c5de9de8"
import script from "./UserActivityTab.vue?vue&type=script&lang=js"
export * from "./UserActivityTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports